module.exports = __webpack_public_path__ + "assets/img/00067.574e5a7a.png";